import React, {Component} from 'react';
import Action from 'actions';
import Const from 'constants';
import $ from 'jquery';
import UserAgent from 'helpers/device';
import Tooltip from 'components/atoms/tooltip';

class ModeTabs extends Component {
    onSelectPlayersType(e, mode) {
        e.preventDefault();
        this.props.dispatch(Action.do('filterByPlayersType', mode));
    }

    calcPlayersQuantityByMode(mode) {
        const {players} = this.props;
        const {playersCount, excludedByMode} = players.data;

        let quantity = playersCount;

        if (excludedByMode.hasOwnProperty(mode)) {
            quantity -= excludedByMode[mode];
        }

        return quantity;
    }

    getOverallTab(params = {}) {
        const {isActive, playersQuantity} = params;

        return (
            <li className={`filter-players-pool${isActive ? ' active' : ''}`}>
                <a href="#" onClick={(e) => ::this.onSelectPlayersType(e, Const.OVERALL_MODE)}>
                    All Players&nbsp;
                    <span className="all-players-counter counter">{playersQuantity}</span>
                </a>
            </li>
        );
    }

    getFavoriteTab(params = {}) {
        const {isActive, playersQuantity} = params;

        return (
            <li className={`filter-players-pool${isActive ? ' active' : ''}`}>
                <a href="#" onClick={(e) => ::this.onSelectPlayersType(e, Const.FAVORITE_MODE)}>
                    My Players&nbsp;
                    <span className="mypool-players-counter counter">{playersQuantity}</span>
                </a>
            </li>
        );
    }

    getExcludedTab(params = {}) {
        const {isActive, playersQuantity} = params;

        return (
            <li className={`filter-players-pool${isActive ? ' active' : ''}`}>
                <a href="#" onClick={(e) => ::this.onSelectPlayersType(e, Const.EXCLUDED_MODE)}>
                    My Exclusions&nbsp;
                    <span className="excluded-players-counter counter">{playersQuantity}</span>
                </a>
            </li>
        );
    }

    getLockTab(params = {}) {
        const {isActive, playersQuantity, playersSalary = false} = params;

        const counterContent =
            playersSalary === false ? (
                <span className="counter">
                    <span className="locked-players-counter">{playersQuantity}</span>
                </span>
            ) : (
                <span className="counter">
                    <span className="locked-players-counter">{playersQuantity}</span>
                    &nbsp;|&nbsp;
                    <span className="locked-players-salary locked-sal">${playersSalary}</span>
                </span>
            );

        return (
            <li className={`filter-players-pool${isActive ? ' active' : ''}`}>
                <a href="#" onClick={(e) => ::this.onSelectPlayersType(e, Const.LOCKED_MODE)}>
                    Locked Players&nbsp;
                    {counterContent}
                </a>
            </li>
        );
    }

    getCustomTab(params = {}) {
        const {isActive, playersQuantity, tooltip, modeName, mode} = params;

        return (
            <li className={`filter-players-pool${isActive ? ' active' : ''}`}>
                <a href="#" onClick={(e) => ::this.onSelectPlayersType(e, mode)}>
                    <Tooltip subject={tooltip} />
                    &nbsp;{modeName}&nbsp;
                    <span className="all-players-counter counter">{playersQuantity}</span>
                </a>
            </li>
        );
    }

    getCaptainTab(params = {}) {
        const {modeName} = params;

        return this.getCustomTab({
            modeName: 'CPT',
            mode: Const.CAPTAIN_MODE,
            tooltip: `Toggle the ${modeName} box to set ${modeName} exposures`,
            ...params,
        });
    }

    getStarTab(params = {}) {
        const {modeName} = params;

        return this.getCustomTab({
            modeName: 'STAR',
            mode: Const.STAR_MODE,
            tooltip: `Toggle the ${modeName} box to set ${modeName} exposures`,
            ...params,
        });
    }

    getProTab(params = {}) {
        const {modeName} = params;

        return this.getCustomTab({
            modeName: 'PRO',
            mode: Const.PRO_MODE,
            tooltip: `Toggle the ${modeName} box to set ${modeName} exposures`,
            ...params,
        });
    }

    getFlexTab(params = {}) {
        return this.getCustomTab({
            modeName: 'FLEX',
            mode: Const.FLEX_MODE,
            tooltip: `Use the FLEX button to modify FLEX exposures`,
            ...params,
        });
    }
}

function tabWidth() {
    if (UserAgent.isMobile()) {
        let body = parseInt($(window).width());
        $('.table-tab-mobile').css({width: body - 15});
    }
}

export {ModeTabs, tabWidth};
